import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUserInfo } from "reducers/userInfo";

import { fetchVerificationStatus } from "reducers/verification";

export const useCheckVerification = (isSignedIn: boolean) => {
  const [dataFetched, setDataFetched] = useState<boolean>(false);
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);

  useEffect(() => {
    if (
      isSignedIn &&
      userInfo.userInfo?.userType &&
      userInfo.userInfo?.userType === "VenueGroup" &&
      !dataFetched
    ) {
      setDataFetched(true);
      dispatch(fetchVerificationStatus());
    }
  }, [dispatch, isSignedIn, userInfo]);
};
